import {STORAGE_KEY, COOKIE_NAMES} from '../constants'

// Getting the button style value
export const getButtonStyle = (style) => {
    if (style && style === 'btn-curve') {
        return '3rem'
    }
}

// Getting the alignment value
export const getAlignment = (alignment) => {
    if (alignment && alignment === 'left') {
        return '15%'
    } else if (alignment && alignment === 'center') {
        return '50%'
    } else {
        return '85%'
    }
}

// Function to convert string like "height-400" into a value like 400px
export const getHeight = (heightString) => {
    if (heightString) {
        const heightNumber = parseInt(heightString.split('-')[1]) // Extracting the number part after "-"
        const data = `${heightNumber}px` // Adding "px" unit
        return data
    }
}

export const customCategoryUrlBuilder = (url, buildUrl) => {
    if (url && buildUrl) {
        const extractedPath = url.split('/').slice(0, -1).filter(Boolean).at(-1)
        const finalUrl = `/collections/${extractedPath}`
        return finalUrl
    } else {
        return ''
    }
}

/**
 * Function to build custom query params
 * @param {Object} parameters
 * return {Array} result
 */
export const buildQueryParams = (parameters) => {
    const result = []
    for (let key in parameters) {
        if (key !== undefined && parameters[key].length > 0) {
            result.push(parameters[key])
        }
    }
    return result
}

/**
 * Function to find full name based on code
 * @param {String} code - The value to search (e.g., country code or language code)
 * @param {Array} options - The list of option objects with `value` and `label`
 * @returns {String} - The matching label or the original code if not found
 */
export const findFullName = (countrycode, options) => {
    if (!countrycode || !Array.isArray(options)) return countrycode
    const option = options.find((item) => item.value?.toLowerCase() === countrycode?.toLowerCase())
    return option ? option.label : countrycode
}

/**
 * Function to format date from "2025-06-01T08:00:00.000Z" to "01/06/2025"
 * @param {String} countryCode
 * @param {Object} options
 * return {String} result
 */
export const formattedDate = (dateString) => {
    const orderDate = new Date(dateString)
    const month = orderDate.getMonth() + 1
    const day = orderDate.getDate()
    const year = orderDate.getFullYear()

    return `${month}/${day}/${year}`
}

/**
 * Formats the given phone number to add spaces and symbols
 * @param {string} - Phone number to be formatted
 * @returns {string}  - Formatted phone number
 */
export const formatPhoneNumber = (value, countryCode) => {
    if (!value) return value
    const phoneNumber = value.replace(/[^\d]/g, '')
    const phoneNumberLength = phoneNumber.length
    if (phoneNumberLength < 4) return phoneNumber
    if (countryCode === 'US' || countryCode === 'CA') {
        if (phoneNumberLength < 7) {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`
        }
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`
    }
    return phoneNumber
}

/**
 * Function to return inventory status of a product
 * @param {Object} product
 * return {String} result
 */
export const inventoryStatus = (product) => {
    if (
        product?.inventory?.preorderable
            ? product?.inventory?.preorderable === true
            : product?.representedProduct?.c_preorderFlag === true
    ) {
        return 'Pre-Order'
    } else if (
        product?.inventory?.backorderable
            ? product?.inventory?.backorderable === true
            : product?.representedProduct?.c_backorderFlag === true
    ) {
        return 'Backorder'
    } else if (
        product?.inventory?.ats
            ? product?.inventory?.ats === 0
            : !product?.representedProduct?.c_inStockFlag === true
    ) {
        return 'Out of Stock'
    } else {
        return 'In Stock'
    }
}

/**
 * Function to get Device Type
 * return {String} result
 */
export const getDeviceTypeByScreenSize = () => {
    const width = window && window?.innerWidth
    if (width) {
        if (width <= 768) {
            return 'Mobile'
        } else if (width > 768 && width <= 1024) {
            return 'Tablet'
        } else {
            return 'Desktop'
        }
    } else {
        return 'Desktop'
    }
}

export const searchPageType = () => {
    const path = window.location.pathname

    if (path === '/' || path === '/home') return 'Home'
    if (path.includes('/search')) return 'Search Results'
    if (path.includes('/collections')) return 'Collections'
    if (path.includes('/product/')) return 'Products'

    return 'Other'
}

/**
 * Function to get cookie id
 * return {String} result
 */
export const getCookieId = (cookieName) => {
    if (typeof window != 'undefined') {
        const cookies = document?.cookie?.split('; ')
        const key = cookieName || '_ga'

        const cookie = cookies?.find((cookie) => {
            const tokens = cookie.split('=')
            const cookieKey = tokens[0].trim()
            return cookieKey === key
        })
        let cookieId

        if (cookie) {
            const tokens = cookie.split('=')
            if (key === '_ga') {
                const gaCookieValue = tokens[1].split('.')
                cookieId = gaCookieValue[2] + '.' + gaCookieValue[3]
                return cookieId
            } else {
                cookieId = tokens[1]
                return cookieId
            }
        }
    }

    return null // Return null if cookie not found
}
export const createCookie = (cname, cvalue, mins) => {
    if (typeof window != 'undefined') {
        const date = new Date()
        date.setTime(date.getTime() + mins * 60 * 1000)
        let expires = 'expires=' + date.toUTCString()
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
    }
}

/**
 *  Page type
 *  categorize page type based on URL or page structure
 */
export const getPageType = () => {
    if (typeof window != 'undefined') {
        const path = window.location.pathname

        if (path === '/' || path === '/home') return 'Home'
        if (path.startsWith('/search') || path.includes('/collections')) return 'Collections'
        if (path.includes('/products/')) return 'Products'
        if (path.includes('/write-a-review/')) return '/write-a-review'

        return 'Other'
    }
}

/*
 * This is used to get Url Path for content assests and others
 */
/*
 * This is used to get Url Path for content assests and others
 */
export const getPath = (fullUrl, site, locale) => {
    if (!fullUrl) {
        return
    }

    const path = {
        isExternalURL: false,
        url: fullUrl
    }
    // Skip processing for relative paths (starting with /)
    if (typeof fullUrl === 'string' && fullUrl.startsWith('/')) {
        return path
    }

    const siteId = site?.id
    const localeCode = locale?.id
    const urlObj = new URL(fullUrl)
    if (!urlObj.hostname.includes('commercecloud.salesforce.com')) {
        path.isExternalURL = true
        path.url = fullUrl
        return path
    }

    const pattern = new RegExp(`^https?://[^/]+/s/${siteId}/${localeCode}`, 'i')
    path.url = fullUrl.replace(pattern, '')

    return path
}

/*
 * This is used to get Url Path for page designers and other URL's
 */
export const getPDPath = (url, site, locale) => {
    if (typeof url !== 'string') return url
    if (url.startsWith('/')) return url

    try {
        // Handle full URLs
        const urlObj = new URL(url)
        // Handle Salesforce commerce URLs
        if (urlObj.hostname.includes('commercecloud.salesforce.com')) {
            const prefix = `/s/${site?.id}/${locale?.id}`
            if (urlObj.pathname.startsWith(prefix)) {
                return urlObj.pathname.slice(prefix.length) || '/'
            }
        }

        return urlObj.pathname
    } catch (e) {
        return url
    }
}

export const getCookie = (name) => {
    if (typeof document === 'undefined') return null

    const match = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'))
    return match ? decodeURIComponent(match[2]) : null
}

/**
 * Returns an object with `userID` and `householdId`.
 * userID is either hashed email (if logged in), or session ID (guest fallback).
 * householdId is customerId if available.
 */
export function getUserIdentifiers(customer) {
    // Customize this if your session ID cookie has a different name
    const SESSION_COOKIE_NAME = 'sid'
    let userID = ''
    const householdId = customer?.customerId || ''

    if (customer?.email) {
        userID = customer.email.toLowerCase()
    }

    if (!userID) {
        const sessionID = getCookie(SESSION_COOKIE_NAME)
        userID = sessionID || ''
    }

    return {userID, householdId}
}

/**
 * SHA-256 hash utility to safely hash email or identifiers
 */
export async function sha256(str) {
    const encoder = new TextEncoder()
    const data = encoder.encode(str)
    const hash = await crypto.subtle.digest('SHA-256', data)
    return Array.from(new Uint8Array(hash))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('')
}

export const handleGeoCountryPopup = ({
    multiCountryList,
    shopperGeoLocation,
    openCountryModal,
    setGeoSessionData,
    site
}) => {
    const pageType = getPageType()
    const countryCode = shopperGeoLocation?.CountryCode

    if (
        multiCountryList &&
        countryCode &&
        !localStorage.getItem('countrySelectorShown') &&
        pageType !== 'Other'
    ) {
        const regionalList = multiCountryList?.content?.regionalList || []
        const countriesList = multiCountryList?.content?.countryList || []
        const languageList = multiCountryList?.content?.lanaguageList || []

        const restrictedRegion =
            site?.id === 'CrunchyrollAU' ? 'AU' : site?.id === 'CrunchyrollUS' ? 'US' : 'EU'

        let matchedRegion = null
        let matchedCountry = null
        let matchedLanguage = null

        for (const region of regionalList) {
            const regionCountries = region.countryList.split(',').map((c) => c.trim())
            if (regionCountries.includes(countryCode) && region.region !== restrictedRegion) {
                matchedRegion = region
                matchedCountry =
                    countriesList.find((c) => c.countryCode === countryCode) || countriesList[0]
                const langs = matchedCountry?.languages?.split(',') || []
                matchedLanguage =
                    languageList.find((l) => l.languageCode === langs[0]) || languageList[0]
                break
            }
        }

        if (matchedRegion && matchedCountry && matchedLanguage) {
            const selectedCountryRegionLanguage = {
                country: {value: matchedCountry.countryCode, label: matchedCountry.countryName},
                language: {
                    value: matchedLanguage.languageCode,
                    label: matchedLanguage.languageName
                },
                region: {value: matchedRegion.region, label: matchedRegion.displayName}
            }

            localStorage.setItem(
                'selectedCountryRegionLanguage',
                JSON.stringify(selectedCountryRegionLanguage)
            )
            localStorage.setItem('countrySelectorShown', 'true')
            openCountryModal()
            setGeoSessionData(selectedCountryRegionLanguage)
        }
    }
}

/*
 * Returns display text for a link based on the provided item and type
 */
export const getLinkText = (item, type) => {
    switch (type) {
        case 'product':
            return item?.productId
        case 'category':
            return item?.name + ' in ' + item?.parentCategoryName
        case 'popularSearch':
            return item?.value
        case 'suggestionSearch':
            return item?.name
        default:
            return ''
    }
}

/*
 * This is used to get categories data defined in content assets for headermenu
 */
export const getListMenuCategories = (headerMenuContentAssets) => {
    if (!headerMenuContentAssets || Object.keys(headerMenuContentAssets).length === 0) return []

    const parser = new DOMParser()
    const result = Object.keys(headerMenuContentAssets)
        .map((headerMenuContentAsset) => {
            const block =
                (headerMenuContentAssets?.[headerMenuContentAsset]?.body &&
                    parser.parseFromString(
                        headerMenuContentAssets[headerMenuContentAsset].body,
                        'text/html'
                    )) ||
                ''
            if (!block) return null
            const imageBlock = block.querySelector('.image-src-block')
            const textBlock = block.querySelector('.image-subtext-block')

            const style = imageBlock?.getAttribute('style')
            const urlMatch = style?.match(/url\('([^']+)'\)/)
            const href = imageBlock?.getAttribute('href')
            const id = href?.match(/collections\/([^/]+)/)?.[1] || null

            return {
                imageUrl:
                    headerMenuContentAssets?.[headerMenuContentAsset]?.disImageURL ||
                    (urlMatch ? urlMatch[1] : null),
                id: id,
                title: textBlock?.textContent?.trim()
            }
        })
        .filter((item) => item && item.imageUrl && item.id && item.title)
    return result
}

export const trackTAPurchaseEvent = (productId, refUseCase, c_countryCode, c_regionCode) => {
    if (!productId) return
    const TA_TRACKING_KEY = 'taRefTrackingData'
    const newEntry = {
        productId,
        refUseCase,
        meta: {
            CC: c_countryCode || '',
            CR: c_regionCode || ''
        }
    }

    // Get existing data from localStorage or initialize as empty array
    const existingData = localStorage.getItem(TA_TRACKING_KEY)
    let refUseCaseArray = []

    try {
        refUseCaseArray = existingData ? JSON.parse(existingData) : []
    } catch (e) {
        console.error('Failed to parse TA tracking data from localStorage', e)
    }

    // Find and update existing entry, or push new
    const existingEntry = refUseCaseArray.find((item) => item.productId === productId)

    if (existingEntry) {
        existingEntry.refUseCase = refUseCase
    } else {
        refUseCaseArray.push(newEntry)
    }

    // Store updated array back in localStorage
    localStorage.setItem(TA_TRACKING_KEY, JSON.stringify(refUseCaseArray))
}

/**
 * Build custom query parameters string from an object
 */
export const buildCustomQueryParams = (parameters = {}) => {
    return Object.entries(parameters)
        .filter(([key, value]) => key && value?.length > 0)
        .map(([key, value]) => `c_${key}=${value}`)
        .join('&')
}

/**
 * Build bread crunbs
 */
export const getBreadcrumbIds = () => {
    const breadcrumbItems = Array.from(document.querySelectorAll('nav.sf-breadcrumb ol li'))
    let taxonomyArray = breadcrumbItems
        .map((item) => item.textContent.trim().replace(/\/$/, ''))
        .filter((text) => !!text)
    return taxonomyArray
}

/**
 * Get user consent status
 */
export const hasUserGivenConsent = (consentType) => {
    if (typeof document === 'undefined') return false

    const cookieName = COOKIE_NAMES[consentType]
    const cookieValue = document.cookie.split('; ').find((row) => row.startsWith(`${cookieName}=`))
    const hasLocalStorageFlag = localStorage.getItem(STORAGE_KEY) === 'true'

    if (!cookieValue) return hasLocalStorageFlag

    if (consentType === 'onetrust') {
        const decoded = decodeURIComponent(cookieValue.split('=')[1] || '')
        if (decoded.includes('groups=') || decoded.includes('isIABGlobal=false')) {
            return true
        }
        return hasLocalStorageFlag
    }

    return false
}

/**
 * To get the full name of the matched size variant
 */
export const getSizeVariantFullName = (variationValues, variationAttributes) =>
    variationValues && variationAttributes
        ? Object.entries(variationValues)
              .map(([key, value]) => {
                  const attr = variationAttributes.find((a) => a.id === key)
                  return attr?.values?.find((v) => v.value === value)?.name
              })
              .filter(Boolean)
              .join(', ')
        : null

/**
 * Converting x-geolocation header from string to object
 */
export const parseGeoString = (str) => {
    return str.split(';').reduce((acc, part) => {
        const [key, value] = part.split(':').map((s) => s.trim())
        if (key && value !== undefined) {
            acc[key] = value
        }
        return acc
    }, {})
}

/**
 * Replaces the input text to sanitize it
 * @param {String} input
 * @returns {String} input
 */
export const sanitizeInput = (input) => {
    return input.replace(/[<>&'"/]/g, function (match) {
        const map = {
            '<': '&lt;',
            '>': '&gt;',
            '&': '&amp;',
            "'": '&#39;',
            '"': '&quot;',
            '/': '&#x2F;'
        }
        return map[match]
    })
}

/*
 * creating canonical url
 */
export const getCanonicalURL = (appOrigin) => {
    if (typeof window !== 'undefined') {
        return window.location.href
    } else {
        return appOrigin
    }
}

// Check if the customer belongs to any of the product's customer groups
export function isCustomerInProductGroups(productCustomerGroups, customerGroups) {
    // If product has no groups → no restriction
    if (!productCustomerGroups?.length) {
        return true
    }

    // If product has groups, customer must match at least one
    return customerGroups?.some((groupId) => productCustomerGroups.includes(groupId)) || false
}
